import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=a95ade22&scoped=true&"
import script from "./studentInfo.vue?vue&type=script&lang=js&"
export * from "./studentInfo.vue?vue&type=script&lang=js&"
import style0 from "./studentInfo.vue?vue&type=style&index=0&id=a95ade22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95ade22",
  null
  
)

export default component.exports